import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)


let ROUNTER_ARR = [
    {
        path: '/',
        name: 'home',
        component: (resolve) => require(["@/pages/home"], resolve),
        meta:{
            keywords:'全王科技',
            content:'互联网 + 软件技术 + 人工智能'
        }
    },
    {
        path: '/invoiceMaster',
        name: 'invoiceMaster',
        component: (resolve) => require(["@/pages/invoiceMaster/invoiceMaster"], resolve),
        meta:{
            keywords:'查票大师',
            content:'快捷查验真伪 源头合规管控发票'
        }
    },
    {
        path: '/restoration',
        name: 'restoration',
        component: (resolve) => require(["@/pages/photoRestoration/restoration"], resolve),
        meta:{
            keywords:'老照片修复',
            content:'全王科技以“科技服务人民”为使命，致力于以人工智能为驱动, 打造软件解决方案一站式生态服务平台，服务全国万千用户。'
        }
    },
    {
        path: '/positionMaster',
        name: 'positionMaster',
        component: (resolve) => require(["@/pages/locationHome/locationHome"], resolve),
        meta:{
            keywords:'定位应用大师',
            content: '最新版实时移动手机号码定位器，您可通过搜索号码，在实时GPS地图上查找追踪电话号码位置。拥有定位应用大师，守护亲人的安全。'
        }
    }
]

let routes = new Router({
    mode: 'history',  //去掉url中的#
    routes: ROUNTER_ARR
})

routes.beforeEach(({ meta, path }, from, next) => {
    // 自动改变页面title
    if(meta){
        let newmeta = document.createElement('meta');
        document.querySelector('meta[name="keywords"]').setAttribute('content', meta.keywords)
        document.querySelector('meta[name="description"]').setAttribute('content', meta.content)

        newmeta = meta
    }
    next()
})


export default routes


// WEBPACK FOOTER //
// ./src/router/index.js